import { render, staticRenderFns } from "./BannerBrandPlataformImageSection.vue?vue&type=template&id=71fcf736"
import script from "./BannerBrandPlataformImageSection.vue?vue&type=script&lang=ts"
export * from "./BannerBrandPlataformImageSection.vue?vue&type=script&lang=ts"
import style0 from "./BannerBrandPlataformImageSection.vue?vue&type=style&index=0&id=71fcf736&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports